import {
    setElementOnClick,
    createDivIn,
    setElementInnerText,
    setElementInnerHTML,
    createSpanIn,
    createLinkIn,
    createImgIn,
} from '../ui_utils/DomUtils'
import {ArrayUtils} from '@colonist/utils'
import {UIAjaxWrapper} from '../network/UIAjaxWrapper'
import {UIAPIEndpoints} from '../network/UIAPIEndpoints'
import {
    Championship25ParsedData,
    Championship25Partner,
} from '../../../../shared/Championship25Types'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {LobbyImage} from '@colonist/types'
import {PlayerColor} from '@colonist/game-states'

type ReplayData = {gameId: string, playerColor: PlayerColor} | {slug: string}

const FINAL_REPLAYS: ReplayData[] = [
    {slug: 'gQYTA2vXZQV9fT2n'},
]

const SEMIFINAL_REPLAYS: ReplayData[] = [
    {gameId: '191208779', playerColor: 11},
    {gameId: '191208784', playerColor: 5},
    {gameId: '191208346', playerColor: 3},
    {gameId: '191208573', playerColor: 5},
]

const QUARTERFINAL_REPLAYS: ReplayData[] = [
    {gameId: '191197897', playerColor: 2},
    {gameId: '191197330', playerColor: 1},
    {gameId: '191196681', playerColor: 4},
    {gameId: '191198102', playerColor: 2},
    {gameId: '191199121', playerColor: 2},
    {gameId: '191196320', playerColor: 5},
    {gameId: '191196489', playerColor: 5},
    {gameId: '191196952', playerColor: 1},
    {gameId: '191197221', playerColor: 11},
    {gameId: '191197079', playerColor: 1},
    {gameId: '191196444', playerColor: 4},
    {gameId: '191197644', playerColor: 1},
    {gameId: '191197558', playerColor: 5},
    {gameId: '191196948', playerColor: 12},
    {gameId: '191196835', playerColor: 6},
    {gameId: '191196714', playerColor: 1},
]

export class UIChampionship25Controller {
    constructor() {
        UIChampionship25Controller.renderResults()
        void UIChampionship25Controller.loadContent()
    }

    private static async loadContent() {
        try {
            const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiChampionship25Content(), undefined)
            if(response == undefined) return
            const data = response.json as Championship25ParsedData
            if(data == undefined) return
            if(Array.isArray(data.partners)) {
                UIChampionship25Controller.renderPartners(data.partners)
            }
        } catch(e) {
            return
        }
    }

    private static renderResults() {
        const finalGrid = document.getElementById('championship25-final-grid')
        const semifinalsGrid = document.getElementById('championship25-semifinals-grid')
        const quarterfinalsGrid = document.getElementById('championship25-quarterfinals-grid')

        if(finalGrid) UIChampionship25Controller.renderResultCards(finalGrid, FINAL_REPLAYS)
        if(semifinalsGrid) UIChampionship25Controller.renderResultCards(semifinalsGrid, SEMIFINAL_REPLAYS)
        if(quarterfinalsGrid) UIChampionship25Controller.renderResultCards(quarterfinalsGrid, QUARTERFINAL_REPLAYS)
    }

    private static renderResultCards(container: HTMLElement, replays: ReplayData[]) {
        replays.forEach((replay, index) => {
            const cardDiv = createDivIn(container, 'result-card')
            const infoDiv = createDivIn(cardDiv, 'result-info')
            createSpanIn(infoDiv, 'result-title', {key: 'strings:colonistCommon.utils.#buffer', options: {value: `Table ${index + 1}`}})

            const replayUrl = UIChampionship25Controller.getReplayUrl(replay)
            const replayLink = createLinkIn(cardDiv, replayUrl, {key: 'strings:colonistCommon.utils.emptyString'}, 'replay-btn', undefined, true)
            createImgIn(replayLink, LobbyImage.ReplayIcon)
        })
    }

    private static getReplayUrl(replay: ReplayData): string {
        if(UIUtilsEjsVariables.isUserOnDiscord) {
            if('slug' in replay) return `/replay/${replay.slug}`
            return `/replay?gameId=${replay.gameId}&playerColor=${replay.playerColor}`
        }

        const replayUrl = new URL(window.location.href)
        replayUrl.pathname = UIUtilsEjsVariables.isUserOnMobileAppOrWeb ? '/mobile/replay' : '/replay'
        if('slug' in replay) replayUrl.pathname += `/${replay.slug}`
        else {
            replayUrl.searchParams.set('gameId', replay.gameId.toString())
            replayUrl.searchParams.set('playerColor', replay.playerColor.toString())
        }
        return replayUrl.href
    }

    private static renderPartners(partners: Championship25Partner[]) {
        const partnersTitleElement = document.getElementById('championship25-partners-title') as HTMLElement
        const partnerElements: HTMLElement[] = []
        const viewAllPartnersBtn = document.getElementById('championship25-view-all-partners-btn') as HTMLElement
        const partnersGrid = document.getElementById('championship25-partners-grid') as HTMLDivElement

        setElementInnerText(partnersTitleElement, {key: 'strings:colonistCommon.utils.#buffer', options: {value: `Partners (${partners.length})`}})
        setElementInnerHTML(partnersGrid, {key: 'strings:colonistCommon.utils.emptyString'})

        const shuffledPartners = ArrayUtils.shuffle(partners)

        for(const partner of shuffledPartners) {
            const item = createDivIn(partnersGrid, 'partner-item')
            if(!UIUtilsEjsVariables.isUserOnDiscord && (partner.imageUrl != undefined && partner.imageUrl.length > 0)) {
                const partnerImg = document.createElement('img')
                partnerImg.src = partner.imageUrl
                partnerImg.alt = partner.name
                item.appendChild(partnerImg)
            }
            const nameDiv = createDivIn(item, 'partner-name')
            setElementInnerText(nameDiv, {key: 'strings:colonistCommon.utils.#buffer', options: {value: partner.name}})
            partnerElements.push(item)
        }

        const total = partners.length
        const limit = window.innerWidth <= 991 ? 6 : 14

        if(total <= limit) {
            viewAllPartnersBtn.classList.add('hidden')
            return
        }

        for(let i = limit; i < total; i++) {
            partnerElements[i].classList.add('hidden')
        }

        setElementOnClick(viewAllPartnersBtn, () => {
            for(const item of partnerElements) item.classList.remove('hidden')
            viewAllPartnersBtn.classList.add('hidden')
        }, true)
    }
}
